import React from 'react';

const StarCell = React.createClass({
    getDefaultProps : function(){
        return {'small' : 1}
    },
    propsType : {
        'star' : React.PropTypes.number.isRequired,
        'small' : React.PropTypes.number 
    },
    render : function(){
        var img = '/img/critlib/stars';
        if (this.props.small == 1){
            img += 'little'
        }
        img += '_' + this.props.star + '.gif';

        return (
            <img src={img} alt={this.props.star/2 + 'étoiles'} />
        )
    }

});

export default StarCell;



// WEBPACK FOOTER //
// ./shared/StarCell.jsx